/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";

export const RowIndex = ( cellContent, row, rowIndex,{paginationOptions}) => (
  <>
{rowIndex+(paginationOptions.page-1)*paginationOptions.sizePerPage+1}
  </>
);
